<template>
  <NuxtPwaManifest />
  <NuxtLoadingIndicator color="var(--color-secondary-500)" />
  <Toast
    group="theme-suggestion"
    position="bottom-center"
    :pt="{
      root: { class: 'z-[9999]' },
      message: { class: '!bg-transparent !border-0 !shadow-none !p-0 mb-3' },
    }"
  >
    <template #container="{ closeCallback }">
      <LayoutSuggerimentoTema @accetta="accettaTemaScuro(closeCallback)" @rifiuta="rifiutaTemaScuro(closeCallback)" />
    </template>
  </Toast>
  <NuxtLayout>
    <LayoutAggiornamentoPwa :disponibile="!!$pwa?.needRefresh" @ricarica="$pwa?.updateServiceWorker()" />
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useToast } from "primevue/usetoast";

const toast = useToast();
const ui = useUiStore();
usePrimeVueLocale();

function accettaTemaScuro(chiudi: () => void): void {
  ui.impostaTema(true);
  chiudi();
}

function rifiutaTemaScuro(chiudi: () => void): void {
  // Marca la scelta come fatta: niente più suggerimenti
  ui.rifiutaSuggerimentoTema();
  chiudi();
}

// Propone il tema scuro se il sistema lo usa e l'utente non ha ancora scelto
function suggerisciTemaScuro(): void {
  const preferisceScuro = window.matchMedia?.("(prefers-color-scheme: dark)").matches;
  if (ui.temaScelto || !preferisceScuro) return;
  toast.add({ group: "theme-suggestion", severity: "info", life: 0 });
}

onMounted(suggerisciTemaScuro);
</script>
